import { DefaultPageHeader } from 'layouts';
import { Card, Skeleton } from 'ui';
import { VideosSlider } from 'features/videos';
import { useOrganizationRequestContent } from '../hooks';
import { AllVideos } from './all-videos';

type P = {
  getPathToVideoDetail: (id: string) => string;
  navigateToVideos: () => Promise<void>;
  organizationId: string;
};

const ChannelsVideos = ({ getPathToVideoDetail, navigateToVideos, organizationId }: P) => {
  const { allOrganizations, isLoadingOrganizations, requestOrganizationId } = useOrganizationRequestContent({
    organizationId,
  });

  return (
    <>
      <DefaultPageHeader title="Videos" />
      {isLoadingOrganizations || !allOrganizations ? (
        <Skeleton active paragraph={{ rows: 16 }} />
      ) : (
        <>
          <VideosSlider
            controls={{ title: 'Featured' }}
            getPathToVideoDetail={getPathToVideoDetail}
            query={{ filter: { organizationId: requestOrganizationId, scope: 'channels' } }}
          />
          <Card title={<Card.Title level={2}>All</Card.Title>}>
            <AllVideos
              getPathToVideoDetail={getPathToVideoDetail}
              navigateToVideos={navigateToVideos}
              organizationId={requestOrganizationId}
            />
          </Card>
        </>
      )}
    </>
  );
};

export default ChannelsVideos;
